import { Toast, Indicator } from 'mint-ui'

let loadingCounter = 0

export class UIUtil {
  public static showToast(message: string) {
    Toast(message)
  }

  public static checkFailed<T>(message: string, returnValue: T | boolean = false): T {
    this.showToast(message)

    return returnValue as T
  }

  public static showLoading(text?: string, updateText = false) {
    if (!loadingCounter && !updateText) {
      Indicator.open(text)
    }

    this.updateLoadingText(text)

    if (!updateText) {
      loadingCounter++
    }
    if (loadingCounter > 1) {
      loadingCounter = 1 // 修复多次show的情况
    }
  }

  public static hideLoading() {
    loadingCounter--

    if (!loadingCounter) {
      Indicator.close()
    }
    if (loadingCounter < 0) {
      loadingCounter = 0 // 修复多次hide的情况
    }
  }

  public static updateLoadingText(text?: string) {
    const indicator = document.querySelector('.mint-indicator-text')
    if (indicator) {
      indicator.textContent = text || ''
    }
  }
}
